function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t\t.st0{fill:#A0A998;}\r\n\t\t.st1{fill:#4A4C44;}\r\n\t\t.st2{fill:#FFFFFF;}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M33.5,20.9h-3.3c0.4-0.2,0.6-0.5,0.6-1V7.2c0-0.5-0.3-0.8-0.6-1h8.6l0,1.8c-0.3-0.5-0.8-0.8-1.8-0.8 c-0.5,0-4.1-0.1-4.1-0.1v5.2h3.5c0.3,0,0.6-0.3,0.8-0.6v2.1c-0.1-0.3-0.5-0.6-0.8-0.6h-3.5l0,6.7C32.9,20.4,33.2,20.7,33.5,20.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M40.9,12.6c0.5-0.8,1.6-1.9,2.3-1.9c0.5,0,0.6,0.1,0.8,0.2v2c-0.3-0.4-0.7-0.7-1.3-0.7c-0.8,0-1.5,0.6-1.9,1.2 V20c0,0.5,0.2,0.6,0.6,0.8h-3c0.3-0.2,0.6-0.3,0.6-0.8v-8c0-0.7-0.4-0.8-0.8-0.9l2.6-0.5V12.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M48.9,10.7c1.2,0,3.4,0.4,3.4,2.9c0,1.4,0,5.4,0,5.8c0,0.5,0,0.9,0.6,1l-1.7,0.7c-0.5-0.3-0.7-0.6-0.8-1.6 c-0.7,0.7-1.8,1.6-3.4,1.6c-1.9,0-2.6-1.7-2.6-2.6c0-0.8,0.3-1.8,1.4-2.4c1.1-0.7,3.7-1,4.4-1.7c0.1-0.1,0.1-0.8,0.1-0.9 c0-0.9-0.5-1.9-1.8-1.9c-1.8,0-2.6,1.4-3.1,2.9l0-2.7C46.3,11.3,47.2,10.7,48.9,10.7z M48,19.9c1.1,0,1.8-0.5,2.5-1.1v-3.5 c-0.7,0.3-1.3,0.5-2.3,0.8c-1,0.4-1.8,0.9-1.8,2C46.4,19.2,47,19.9,48,19.9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M63.3,13.7V20c0,0.5,0.2,0.6,0.6,0.8h-2.9c0.4-0.2,0.6-0.3,0.6-0.8v-5.6c0-1.2-0.4-2.5-2.3-2.5 c-0.9,0-1.8,0.6-2.2,1.1v7c0,0.5,0.2,0.6,0.6,0.8h-3c0.3-0.2,0.5-0.3,0.5-0.8v-8c0-0.7-0.3-0.8-0.7-0.9l2.6-0.5v1.5 c0.5-0.5,1.7-1.5,3.1-1.5C61.7,10.7,63.3,11.8,63.3,13.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M74.1,19.9c0.3,0.4,0.6,0.7,1.3,1h-3.8c0.5-0.2,0.5-0.6,0.3-0.8l-3.9-4.3V20c0,0.5,0.2,0.6,0.6,0.8h-3 c0.3-0.2,0.6-0.3,0.6-0.8V7.5c0-0.7-0.4-0.8-0.8-0.9L67.9,6v9.3c0.5-0.4,3.4-3.3,3.4-3.3c0.5-0.5,0.4-0.9-0.2-1.1h3.1 c-0.6,0.3-1,0.5-1.5,0.9c-1,0.9-3.3,3.1-3.3,3.1L74.1,19.9z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M78.3,6v14c0,0.5,0.2,0.6,0.6,0.8h-3c0.3-0.2,0.6-0.3,0.6-0.8V7.4c0-0.7-0.4-0.7-0.8-0.9L78.3,6z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M82.8,10.7V20c0,0.5,0.2,0.6,0.6,0.8h-3c0.3-0.2,0.6-0.3,0.6-0.8v-8c0-0.7-0.4-0.8-0.8-0.9L82.8,10.7z M81.9,6.4c0.6,0,1.1,0.5,1.1,1c0,0.6-0.5,1.1-1.1,1.1c-0.6,0-1.1-0.5-1.1-1.1C80.8,6.9,81.3,6.4,81.9,6.4z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M93.7,13.7V20c0,0.5,0.2,0.6,0.6,0.8h-2.9c0.4-0.2,0.6-0.3,0.6-0.8v-5.6c0-1.2-0.4-2.5-2.3-2.5 c-0.9,0-1.8,0.6-2.2,1.1v7c0,0.5,0.2,0.6,0.6,0.8h-3c0.3-0.2,0.5-0.3,0.5-0.8v-8c0-0.7-0.3-0.8-0.7-0.9l2.6-0.5v1.5 c0.5-0.5,1.7-1.5,3.1-1.5C92.1,10.7,93.7,11.8,93.7,13.7z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M104.8,16.7c0,2.7-2.5,4.4-4.8,4.4c-1.9,0-3.2-0.8-4-1.2L96,16.6c0.5,1.5,1.6,3.5,3.9,3.5 c2.3,0,2.9-1.8,2.9-2.9c0-2.1-1.6-2.5-3.6-3.5c-2.1-1-3.1-2.1-3.1-3.9c0-2.6,2.4-3.8,4.5-3.8c0.8,0,2.1,0.2,3.1,0.8l0.1,2.8 c-0.3-1-1.5-2.8-3.5-2.8c-1.8,0-2.4,1.4-2.4,2.3c0,1.4,0.9,1.9,2.9,2.9C102.8,13.1,104.8,13.8,104.8,16.7z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M108.4,11h3v0.9h-3v6.1c0,2,1.3,2.2,2,2.2c0.9,0,1.1-0.3,1.4-0.6c0,0.6-0.9,1.5-2.2,1.5c-1.7,0-3-1.1-3-3.1 v-6.1h-0.9l2.8-2.9V11z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M115,12.6c0.5-0.8,1.6-1.9,2.3-1.9c0.5,0,0.6,0.1,0.8,0.2v2c-0.3-0.4-0.7-0.7-1.3-0.7c-0.8,0-1.5,0.6-1.9,1.2 V20c0,0.5,0.2,0.6,0.6,0.8h-3c0.3-0.2,0.6-0.3,0.6-0.8v-8c0-0.7-0.4-0.8-0.8-0.9l2.6-0.5V12.6z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M123,21.1c-3,0-4.9-2.6-4.9-5.1c0-2.3,1.7-5.2,4.9-5.2c1.8,0,4,1.3,4,4.5h-7c0,0.2,0,0.4,0,0.6 c0,2.2,1.2,4.1,3.4,4.1c1.5,0,3-1.2,3.4-2.2C127,19.3,125.4,21.1,123,21.1z M120.3,14.4h4.9c0-2.1-1.1-2.9-2.3-2.9 C121.3,11.5,120.4,12.9,120.3,14.4z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M133.1,21.1c-3,0-4.9-2.6-4.9-5.1c0-2.3,1.7-5.2,4.9-5.2c1.8,0,4,1.3,4,4.5h-7c0,0.2,0,0.4,0,0.6 c0,2.2,1.2,4.1,3.4,4.1c1.5,0,3-1.2,3.4-2.2C137,19.3,135.4,21.1,133.1,21.1z M130.3,14.4h4.9c0-2.1-1.1-2.9-2.3-2.9 C131.3,11.5,130.5,12.9,130.3,14.4z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M140.7,11h3v0.9h-3v6.1c0,2,1.3,2.2,2,2.2c0.9,0,1.1-0.3,1.4-0.6c0,0.6-0.9,1.5-2.2,1.5c-1.7,0-3-1.1-3-3.1 v-6.1h-0.9l2.8-2.9V11z"
});

var _ref17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M25,6.3c-0.1,0-0.2,0-0.3,0.1l-0.5,0.3c-0.5,0.3-0.9,0.4-1.5,0.4c-1.4,0.1-2.6,0.2-5.8,0.2h-1.4 c-2,0-3.2-0.1-4.3-0.1c0,0,0,0,0-0.1c0-0.6-0.4-3.6-0.4-4.7c0-0.3-0.1-0.5-0.2-0.5c-0.1,0-0.2,0.1-0.4,0.2L9.7,2.5 c-0.1,0.1-0.3,0.2-0.6,0C8.6,2.3,7.3,1.8,5.7,1.8c-1.6,0-3.1,0.4-4.1,1.4C1.3,3.4,1.1,3.7,0.9,3.9c0,0,0,0,0,0V11 c0.1,0.1,0.2,0.2,0.3,0.3c1.3,1.3,3.4,2.1,4.3,2.4c2.4,0.8,4.5,1.9,4.5,5c0,2.6-2.2,3.7-4,3.7c-1.6,0-3.2-0.8-4.1-2.2 c-0.6-1-0.9-1.7-1-2.4v3.9c0.1,0,0.3,0.1,0.5,0.3c1.2,0.9,2.6,1.5,4.7,1.5c3.9,0,6-3,6-6.4c0-1.9-0.5-3.1-1.3-4c-0.8-1-2-1.5-3.5-2 c0.5-0.9,1.2-2,2.1-2.3c1.1-0.3,3.6-0.3,4.5-0.3h0.7v7.4c0,0.5,0,6.8-0.1,9.3h2.7c0-1.8,0-8.1,0-8.5V8.4h0.8c1.4,0,4.1,0.1,5,0.5 c0.8,0.4,1.5,2,1.9,2.9L25,6.3C25,6.3,25,6.3,25,6.3z M10,7.2c-0.8,0-1.1-0.1-1.6-0.5L8,6.4C7.9,6.4,7.8,6.3,7.6,6.3 c-0.1,0-0.2,0.1-0.3,0.5c0,0.2-0.6,2.4-1,3.9c-0.1,0-0.1,0-0.2-0.1c-0.9-0.3-2.5-0.9-3.4-1.8C2,8.1,1.8,7.2,1.8,6.3 c0-1.5,0.9-3.4,3.6-3.4c1.4,0,2.4,0.4,3.2,1.3c1.1,1.2,1.5,2.2,1.8,3.1C10.3,7.2,10.1,7.2,10,7.2z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M25.1,11.7c-0.4-0.8-1.1-2.5-1.9-2.9c-0.9-0.4-3.6-0.5-5-0.5h-0.8v8.2c0,0.4,0,6.6,0,8.5H22 c0.1,0,0.1,0,0.2,0c-0.7-0.3-1.1-1-1.1-1.7c0-1.1,0.9-1.9,1.9-1.9c0.9,0,1.7,0.7,1.9,1.6c0.1-0.3,0.2-0.6,0.2-0.9V11.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M6,22.4c1.8,0,4-1.1,4-3.7c0-3-2.2-4.1-4.5-5c-0.9-0.3-3-1.1-4.3-2.4C1.1,11.2,1,11.1,0.9,11v6.8 c0.1,0.7,0.3,1.4,1,2.4C2.8,21.6,4.4,22.4,6,22.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1.5,3.2c1.1-1,2.5-1.4,4.1-1.4c1.7,0,3,0.5,3.5,0.7c0.3,0.1,0.4,0.1,0.6,0l0.4-0.4C10.2,2.1,10.3,2,10.5,2 c0.1,0,0.2,0.2,0.2,0.5c0,1,0.4,4,0.4,4.7c0,0,0,0,0,0.1c1.1,0.1,2.3,0.1,4.3,0.1h1.4c3.1,0,4.4-0.1,5.8-0.2c0.6,0,1-0.1,1.5-0.4 l0.5-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0V3.9c0-1.7-1.4-3-3-3H3.9c-1.7,0-3,1.3-3,3C1.1,3.7,1.3,3.4,1.5,3.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M14.8,8.4H14c-0.9,0-3.4,0-4.5,0.3C8.6,9,7.9,10.1,7.4,11.1c1.4,0.5,2.6,1,3.5,2c0.8,0.9,1.3,2.1,1.3,4 c0,3.5-2.1,6.4-6,6.4c-2.1,0-3.5-0.6-4.7-1.5c-0.3-0.2-0.4-0.3-0.5-0.3V22c0,1.7,1.4,3,3,3h10.8c0.1-2.5,0.1-8.8,0.1-9.3V8.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M5.4,2.9c-2.6,0-3.6,1.9-3.6,3.4c0,0.8,0.2,1.8,0.9,2.6c0.9,0.9,2.5,1.5,3.4,1.8c0.1,0,0.1,0,0.2,0.1 c0.4-1.5,1-3.7,1-3.9c0.1-0.4,0.2-0.5,0.3-0.5c0.1,0,0.2,0,0.3,0.1l0.4,0.3C8.9,7.1,9.2,7.2,10,7.2c0.1,0,0.2,0,0.4,0 c-0.2-0.8-0.7-1.9-1.8-3.1C7.8,3.3,6.8,2.9,5.4,2.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M25.1,11.7c-0.4-0.8-1.1-2.5-1.9-2.9c-0.9-0.4-3.6-0.5-5-0.5h-0.8v8.2c0,0.4,0,6.6,0,8.5H22 c0.1,0,0.1,0,0.2,0c-0.7-0.3-1.1-1-1.1-1.7c0-1.1,0.9-1.9,1.9-1.9c0.9,0,1.7,0.7,1.9,1.6c0.1-0.3,0.2-0.6,0.2-0.9V11.7z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M23,21.4c-1.1,0-1.9,0.9-1.9,1.9c0,0.8,0.5,1.4,1.1,1.7c1.2-0.1,2.3-0.9,2.6-2.1C24.8,22.1,24,21.4,23,21.4z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M22,0H3.9C1.8,0,0,1.8,0,3.9V22C0,24.2,1.8,26,3.9,26H22c2.2,0,3.9-1.8,3.9-3.9V3.9C26,1.8,24.2,0,22,0z M25.6,22c0,2-1.6,3.5-3.5,3.5H3.9c-2,0-3.5-1.6-3.5-3.5V3.9c0-2,1.6-3.5,3.5-3.5H22c2,0,3.5,1.6,3.5,3.5V22z"
})));

function SvgFsLogo2022(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 26",
    style: {
      enableBackground: "new 0 0 144 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFsLogo2022);
export default __webpack_public_path__ + "static/media/fs-logo-2022.407539ac.svg";
export { ForwardRef as ReactComponent };